import { CdkOption } from '@angular/cdk/listbox';
import { Directive, inject } from '@angular/core';

@Directive({
  selector: '[cslOption]',
  exportAs: 'cslOption',
  standalone: true,
  hostDirectives: [
    {
      directive: CdkOption,
      inputs: ['cdkOption: cslOption', 'cdkOptionDisabled: cslOptionDisabled'],
    },
  ],
  host: {
    class:
      'csl-option px-4 py-2 text-blue-900 hover:bg-gray-100 cursor-default rounded-none focus:rounded-none focus:outline-none focus:shadow-[inset_0_0_0_2px_#00263E] focus-visible:rounded-none focus-visible:outline-none focus-visible:shadow-[inset_0_0_0_2px_#00263E]',
    '[class.bg-gray-100]': 'cdkOption.isActive() || cdkOption.disabled',
    '[class.text-gray-400]': 'cdkOption.disabled',
    '[class.font-medium]': 'cdkOption.isActive() && cdkOption.isSelected()',
    '[style.border-radius]': '"0px"',
    '[style.outline]': '"none"',
    '[style.box-shadow]': 'cdkOption.isActive() ? "inset 0 0 0 2px #00263E" : null',
  },
})
export class OptionDirective {
  cdkOption = inject(CdkOption);

  isSelected() {
    return this.cdkOption.isSelected();
  }
}
